// import { gsap } from "gsap";

export default class BetssonTabs extends HTMLElement {
  constructor(...args) {
    const self = super(...args);
    self.init();
    return self;
  }

  init() {
    this.tabButtons = [];
    this.tabPanels = [];
    this.activeMenuItemClass = 'menu__item--active';
  }

  connectedCallback() {
    this.resolveElements();
    this.registerEvents();
    this.setActiveTabFromFragment();
    this.equalizePanelsHeight();
    this.observeAnimations();
  }

  resolveElements() {
    this.tabButtons = this.querySelectorAll("button[aria-controls]");
    this.tabPanels = this.querySelectorAll("[role='tabpanel']");
  }

  registerEvents() {
    this.tabButtons.forEach((button) => {
      button.addEventListener("click", this.handleTabClick.bind(this));
    });
  }

  observeAnimations() {
    if (!this.sectionAnimObserver) {
      this.sectionAnimObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            let isHidden = entry.target.closest('[hidden]') !== null;

            if (!isHidden) {
              entry.target.classList.add('animate');
            }
          }
        });
      }, {
        threshold: 0.4
      });
    }

    this.tabPanels.forEach(panel => {
      const animElems = panel.querySelectorAll('[section-anim]');
      animElems.forEach(elem => {
        this.sectionAnimObserver.observe(elem);
      });
    }); 
  }

  unobserveAnimations() {
    this.tabPanels.forEach(panel => {
      const animElems = panel.querySelectorAll('[section-anim]');
      animElems.forEach(elem => {
        elem.classList.remove('animate');
      });
    });
    this.sectionAnimObserver.disconnect();
  }

  setActiveTabFromFragment() {
    const fragment = this.getFragmentFromHash();
    if (!fragment) {
      return;
    }
    this.activateTabByFragment(fragment);
    this.showPanelByFragment(fragment);
  }

  handleTabClick(e) {
    e.preventDefault();
    const targetId = e.currentTarget.getAttribute("aria-controls").replace(/^#/, "");;
    const isAlreadyActive = e.currentTarget.classList.contains(this.activeMenuItemClass);

    if (!targetId || isAlreadyActive) {
      return;
    }

    this.equalizePanelsHeight();
    this.activateTabByFragment(targetId);
    this.showPanelByFragment(targetId);
    this.updateHistory(targetId);
    this.scrollToAnchor();
    this.unobserveAnimations();

    setTimeout(() => {
      this.observeAnimations();
    }, 200);
  }

  scrollToAnchor() {
    const anchor = document.querySelector("#tabs-anchor");
    if (anchor) {
      anchor.scrollIntoView({ behavior: "smooth" });
    }
  }

  getFragmentFromHash() {
    return window.location.hash ? window.location.hash.replace(/^#/, "") : null;
  }

  activateTabByFragment(fragment) {
    this.tabButtons.forEach((button) => {
      const controls = button.getAttribute("aria-controls").replace(/^#/, "");
      if (controls === fragment) {
        button.classList.add(this.activeMenuItemClass);
      } else {
        button.classList.remove(this.activeMenuItemClass);
      }
    });
  }

  equalizePanelsHeight() {
    // First, determine the maximum height among all [data-inner] elements inside panels
    let maxHeight = 0;
    this.tabPanels.forEach((panel) => {
      const inner = panel.querySelector('[data-inner]');
      if (inner) {
        // Temporarily show the panel if hidden to measure accurately
        const wasHidden = panel.hidden;
        panel.hidden = false;
        const innerHeight = inner.offsetHeight;
        if (innerHeight > maxHeight) {
          maxHeight = innerHeight;
        }
        panel.hidden = wasHidden;
      }
    });

    // Set min-height for all [data-inner] elements to the maxHeight found
    this.tabPanels.forEach((panel) => {
      const inner = panel.querySelector('[data-inner]');
      if (inner) {
        inner.style.minHeight = maxHeight + "px";
      }
    });
  }

  showPanelByFragment(fragment) {
    this.tabPanels.forEach((panel) => {
      const isActive = panel.id === fragment;
      panel.hidden = !isActive;

      const salElements = panel.querySelectorAll("[section-anim]");
      salElements.forEach((el) => {
        if (!isActive) {
          el.classList.remove("animate");
        }
      });
    });
  }

  updateHistory(fragment) {
    history.replaceState(null, "", "#" + fragment);
  }
}
